import { Link } from 'react-router-dom'
import { useEntriesOnDate } from '@/hooks/useData'

export default function OnThisDayBanner() {
  const now = new Date()
  const { data } = useEntriesOnDate(now.getMonth() + 1, now.getDate())

  if (!data?.length) return null

  const pastEntries = data.filter(
    e => new Date(e.recorded_at).getFullYear() < now.getFullYear()
  )
  if (!pastEntries.length) return null

  const entry = pastEntries[0]
  const yearsAgo = now.getFullYear() - new Date(entry.recorded_at).getFullYear()

  return (
    <Link
      to="/summary"
      className="mx-4 my-3 flex items-center gap-3 p-3.5 rounded-2xl border border-blue/20 bg-blue/5"
    >
      <div className="w-9 h-9 rounded-xl bg-blue/15 flex items-center justify-center text-lg flex-shrink-0">
        📅
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-mono text-[10px] tracking-widest uppercase mb-0.5" style={{ color: '#7b96ff' }}>
          On This Day · {yearsAgo} {yearsAgo === 1 ? 'year' : 'years'} ago
        </p>
        <p className="text-white text-sm font-medium truncate">{entry.title}</p>
      </div>
      <span className="text-white/20 text-lg flex-shrink-0">›</span>
    </Link>
  )
}

export function YearScroller({
  years,
  selected,
  onSelect,
}: {
  years: number[]
  selected?: number
  onSelect: (y: number) => void
}) {
  return (
    <div className="flex gap-2 px-4 pb-1 overflow-x-auto scrollbar-hide">
      {years.map(y => (
        <button
          key={y}
          onClick={() => onSelect(y)}
          className={`flex-shrink-0 px-4 py-1.5 rounded-xl font-mono text-xs font-medium border transition-all
            ${selected === y
              ? 'border-blue text-blue-light bg-blue/10'
              : 'border-white/[0.07] text-white/30 bg-white/[0.02]'}`}
        >
          {y}
        </button>
      ))}
    </div>
  )
}
